import { apiUrl } from '../../../../api';
import { PRIO } from '../../../../constants';
import { AdvancedMailSearchDto } from '../../../../models/MailSearch';
import { MailFolderId } from '../../../../models/Types';
import equals from 'deep-equal';

export const FETCH_MAIL_SEARCH_ME_REQUEST =
  PRIO + 'FETCH_MAIL_SEARCH_ME_REQUEST';
export const FETCH_MAIL_SEARCH_ME_COMMIT = PRIO + 'FETCH_MAIL_SEARCH_ME_COMMIT';
export const FETCH_MAIL_SEARCH_ME_ROLLBACK =
  PRIO + 'FETCH_MAIL_SEARCH_ME_ROLLBACK';

export const fetchMailSearchMe = (
  searchTerm: AdvancedMailSearchDto | string,
  mailFolderId?: MailFolderId,
  nextLink?: string
) => {
  const isString: boolean = typeof searchTerm === 'string';
  const url: string = isString
    ? `${apiUrl}/email/EmailMe/${
        mailFolderId ? `mailFolder/${mailFolderId}/` : ''
      }message?search=${searchTerm}${nextLink ? `&nextLink=${nextLink}` : ''}`
    : `${apiUrl}/email/EmailMe/${
        mailFolderId ? `mailFolder/${mailFolderId}/` : ''
      }message/search${
        equals(searchTerm, {})
          ? ''
          : `?${Object.keys(searchTerm)
              .filter(
                (key) =>
                  !(searchTerm[key] === undefined || searchTerm[key] === null)
              )
              .map(
                (key) =>
                  `${key}=${
                    Array.isArray(searchTerm[key])
                      ? searchTerm[key].join(',')
                      : searchTerm[key]
                  }`
              )
              .join('&')}`
      }${
        nextLink
          ? `${equals(searchTerm, {}) ? '?' : '&'}nextLink=${nextLink}`
          : ''
      }`;
  return {
    type: FETCH_MAIL_SEARCH_ME_REQUEST,
    requiresAuth: true,
    meta: {
      offline: {
        // the network action to execute:
        effect: {
          url,
          method: 'GET',
        },
        // action to dispatch when effect succeeds:
        commit: {
          type: FETCH_MAIL_SEARCH_ME_COMMIT,
          meta: { searchTerm, nextLink, mailFolderId },
        },
        // action to dispatch if network action fails permanently:
        rollback: {
          type: FETCH_MAIL_SEARCH_ME_ROLLBACK,
          meta: { searchTerm, nextLink, mailFolderId },
          snackbarErrorMessage: {
            label: 'mail:errorMessages.searchMessages.fetchMessagesError',
            timeout: 6,
          },
        },
      },
      searchTerm,
      nextLink,
      mailFolderId,
    },
  };
};
